<template>
  <section
    class="client-listing-area h-100"
    style="background: none !important;width:100%"
  >
    <div class="client-listing-head-fluid">
      <div class="container">
        <div class="client-listing-head">
          <UserBar />
        </div>
        <!-- ends client-listing-head -->
      </div>
    </div>
    <!-- ends client-listing-head-fluid -->
    <div class="client-listing-detail-fluid">
      <div class="container">
        <div class="client-listing-detail">
          <div class="table-responsive">
            <UserList />
          </div>
        </div>
        <!-- ends client-listing-detail -->
      </div>
    </div>
    <!-- ends client-listing-detail-fluid -->
  </section>
</template>

<script>
import UserList from '@/components/users/UserList.vue';
import UserBar from '@/components/users/UserBar.vue';
// import CategoryList from '@/components/dashboard/category/CategoryList.vue';

export default {
  name: 'Users',
  components: { UserBar, UserList },
  mounted() {
    this.changeBodyToWhite();
  },
};
</script>

<style scoped>
.client-listing-head-fluid {
  border-bottom: 0px !important;
}
</style>
